//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import crypto from "crypto"
require("crypto");
export default {
  name: "list-temple",
  data() {
    return {}
  },
  props: ['datalist',
    'template', 'fixHeight'],
  methods: {
    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter: function (el, done) {
      const height = el.offsetHeight;
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          {opacity: 1, height: height},
          {complete: done}
        )
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 20
      setTimeout(function () {
        Velocity(
          el,
          {opacity: 0, height: 0},
          {complete: done}
        )
      },delay)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/list-template.vue